import { FileText, MessageSquareText, Briefcase } from "lucide-react";

export const LANDING_VALUES = [
  {
    icon: FileText,
    titleKey: "landing_contracts_title",
    descKey: "landing_contracts_desc",
    bulletKeys: ["landing_contracts_b1", "landing_contracts_b2", "landing_contracts_b3"],
  },
  {
    icon: MessageSquareText,
    titleKey: "landing_chat_title",
    descKey: "landing_chat_desc",
    bulletKeys: ["landing_chat_b1", "landing_chat_b2", "landing_chat_b3"],
  },
  {
    icon: Briefcase,
    titleKey: "landing_cases_title",
    descKey: "landing_cases_desc",
    bulletKeys: ["landing_cases_b1", "landing_cases_b2", "landing_cases_b3"],
  },
];
